/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ageingruppierung11Inputs */



/**

* @param {_Field_Ageingruppierung11Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ageingruppierung11 = /** @type {((inputs?: _Field_Ageingruppierung11Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ageingruppierung11Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("AG-Eingruppierung 1")
});
export { _field_ageingruppierung11 as "_field_agEingruppierung1" }